<template>
  <crec-modal class="goRegisterDialog" title="" :visible.sync="computedShow" width="400px" append-to-body @ok="handleClose('ok')" @cancel="handleClose('close')" :footer="null">
    <div class="webRegisterBg">
      <crec-form-model  ref="registerForm" :model="registerForm" :rules="registerRules" class="webRegisterForm formRest" label-width="80px">
        <crec-form-model-item prop="phone" label="手机号码">
          <crec-input v-model="registerForm.phone" type="text" autoComplete="off" placeholder="请输入手机号码" />
        </crec-form-model-item>
        <crec-form-model-item prop="password" label="密码" class="passwordEye">
          <crec-input-password v-model="registerForm.password" :type="isPassword?'text':'password'" autoComplete="off" placeholder="请输入密码" @keyup.enter.native="handleRegister">
            <!-- <svg-icon slot="suffix" :icon-class="isPassword?'eye-open':'eye'" class="svgEye" @click="isPassword=!isPassword" /> -->
          </crec-input-password>
        </crec-form-model-item>
        <crec-form-model-item prop="confirmPassword" label="确认密码" class="passwordEye">
          <crec-input-password v-model="registerForm.confirmPassword"  :type="isPassword1?'text':'password'" auto-complete="off" placeholder="请输入确认密码" @keyup.enter.native="handleRegister">
            <!-- <svg-icon slot="suffix" :icon-class="isPassword1?'eye-open':'eye'" class="svgEye" @click="isPassword1=!isPassword1" /> -->
          </crec-input-password>
        </crec-form-model-item>
        <crec-form-model-item prop="code" class="codePhone" label="验证码">
          <crec-input v-model="registerForm.code" autoComplete="off" placeholder="请输入验证码" style="width: 63%" @keyup.enter.native="handleRegister"></crec-input>
          <crec-button class="send-code" @click="getCode()">{{sendmsg}}</crec-button>
        </crec-form-model-item>
        <crec-form-model-item class="registerBox" label-width="0">
          <crec-button
            :loading="loading"
            type="primary"
            @click.native.prevent="handleRegister"
          >
            <span v-if="!loading">注 册</span>
            <span v-else>注 册 中...</span>
          </crec-button>
        </crec-form-model-item>
        <div class="login1">
          <a class="link-type" @click="handleClose('login')" >
            已有账号，立即登录
          </a>
        </div>
      </crec-form-model>
    </div>
  </crec-modal>
</template>

<script>
import { getSmsCode, register } from '@/api/login'
export default {
  name:'RegisterDialog',
  props:{
    show:{
      type:Boolean,
      default:false
    }
  },
  data() {
    const equalToPassword = (rule, value, callback) => {
      // const { getFieldValue } = this.formRef; // 获取表单字段值
      // if (value && value !== getFieldValue('password')) {
        if (value && value !== this.registerForm.password) {
        callback('两次输入的密码不一致!');
      } else {
        callback();
      }
    };
    return {
      // 二维码PK
      pkQrCode:'',
      // 二维码所属单位
      pkCompany:'',
      companyName:'',
      codeUrl: "",
      registerForm: {
        phone: "",
        password: "",
        confirmPassword: "",
        code: "",
        uuid: ""
      },
      registerRules: {
        phone: [
          { required: true, trigger: "blur", message: "请输入您的手机号" },
          { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '手机号格式错误', trigger:  ['blur', 'change']}
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 6, max: 20, message: '用户密码长度必须介于 6 和 20 之间', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ],
        code: [{ required: true, trigger: "blur", message: "请输入验证码" }]
      },
      loading: false,
      captchaOnOff: true,
      // 已发送验证码
      sendCode: false,
      sendmsg:"发送验证码",
      isPassword:false,
      isPassword1:false,
    };
  },
  computed: {
    computedShow: {
      get() {
        return this.show
      }
    }
  },
  created() {
    let bundle = this.$route.query;
    // 二维码PK
    this.pkQrCode = bundle.pkQrCode;
    // 二维码所属单位
    this.pkCompany = bundle.pkCompany;
    this.companyName = bundle.companyName;
    // if(RegexUtil.isEmpty(this.pkQrCode) || RegexUtil.isEmpty(this.pkCompany)){
    //   this.$message.error("缺失相关参数，请重新扫码！");
    //   return ;
    // }
  },
  methods: {
    handleRegister() {
      this.$refs.registerForm.validate(valid => {
        console.log('提交的表单数据：', valid)
        if (valid) {
          console.log('提交的表单数据：')
          this.loading = true;
          const that = this;
          register(this.registerForm).then(() => {
            this.loading = false;
            this.$success({
              title: '系统提示',
              // JSX support
              content: (
                <font color='#32cd32'>恭喜你，您的账号注册成功！</font>
              ),
              onOk() {
                that.handleClose('login')
              }
            });
          }).catch(() => {
            this.loading = false;
          })
        }
      })
    },
    getCode() {
      if (!this.registerForm.phone) {
        return this.$message.warning('请先输入手机号');
      }
      this.isSend = false;
      let timer = 60;
      this.sendmsg = timer + "s";
      this.timeFun = setInterval(() => {
        --timer;
        this.sendmsg = timer + "s";
        if (timer == 0) {
          this.isSend = true;
          this.sendmsg = "重新发送";
          clearInterval(this.timeFun);
        }
      }, 1000);
      getSmsCode(this.registerForm.phone).then(() => {
      });
    },
    handleClose(val) {
      if (val === 'ok') {
        this.handleRegister()
        return
      }
      this.$emit('closeValue',val)
    },
  }
};
</script>

<style lang="less">
.goRegisterDialog{
  .crec-modal-content{
    width: 400px;
    border-radius: 14px;
    
    .webRegisterForm{
          padding: 20px 0 0;
          //height: 450px ;
          .crec-tabs-bar{
            text-align: center;
            margin-bottom: 40px;
          }
          .crec-form-item-label {
            float: left;
            width: 70px;
            font-weight: bold;
          }
          .crec-form-item-control-wrapper {
            margin-left: 70px;
          }
          .registerBox{
            text-align: center;
            margin: 60px 0 0 0;
            .crec-form-item-control-wrapper {
              margin-left: 0 !important;
            }
            .crec-form-item-children {
              display: inline-block;
              width: 80%;
            }
            .crec-btn{
              width: 100%;
              padding: 10px 20px;
              font-size: 14px;
              border-radius: 4px;
              line-height: 1;
            }
          }
          .register,.login1{
            text-align: right;
            & a{color: #1961ac;font-size: 12px}
          }
          .register{margin-top: 60px;}
          .login1{margin-top: 60px;}
          .codePhone {
            .crec-form-item-children {
              display: flex;
            }
            .send-code {
              margin-left: 10px;
              font-size: 12px;
            }
          }
          .passwordEye{
            position: relative;
            .svgEye{
              position: absolute;
              right: 15px;
              top: 10px;
              cursor: pointer;
              color: #666666;
            }
          }
        }
  }
}
</style>